export const WAITING = 'waiting';
export const READ = 'read';
